/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { LargeFeedFilter } from "cms/shared/feeds/large";
import { FeedbackForm } from "components/feedback-form";
import { ModelFeatureGuard } from "cms/model-feature-guard.jsx";
import { FeatureFlagGuard } from "cms/features/feature-flag-guard.jsx";

const EventSearch = () => {

    const type = "model.event";

    return (
        <main>
            <h1 style={{ marginTop: "16px" }}>
                Events
            </h1>

            <LargeFeedFilter
                type={type}
            />

            <FeatureFlagGuard feature="feature_was_helpful">
                <ModelFeatureGuard modelFeature="feedback_form">
                    <FeedbackForm />
                </ModelFeatureGuard>
            </FeatureFlagGuard>

        </main>
    );
};

export { EventSearch };
